import script from "./WebArticleDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./WebArticleDetail.vue?vue&type=script&setup=true&lang=js"

import "./WebArticleDetail.vue?vue&type=style&index=0&id=b1f358d0&scoped=true&lang=scss"
import "./WebArticleDetail.vue?vue&type=style&index=1&id=b1f358d0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1f358d0"]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QSpinnerPie from 'quasar/src/components/spinner/QSpinnerPie.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';import Ripple from 'quasar/src/directives/ripple/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QImg,QBtn,QAvatar,QSpinnerPie,QScrollArea,QList,QItem,QItemSection});qInstall(script, 'directives', {Ripple});
